module.exports = __webpack_public_path__ + "static/media/antenna.8a2e09f6.svg";